"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HBCalloutPopover = require("../HBCalloutPopover/HBCalloutPopover.styles");
var _HBCalloutPopoverContent = _interopRequireDefault(require("../HBCalloutPopover/HBCalloutPopoverContent/HBCalloutPopoverContent"));
var _HBCornerPopup = _interopRequireDefault(require("../HBCornerPopup/HBCornerPopup"));
var _HBDrawer = _interopRequireDefault(require("../HBDrawer/HBDrawer"));
var _useWindowSize2 = require("../common/useWindowSize");
var _excluded = ["isOpen", "onClose", "testId", "testIdName", "calloutTheme", "primaryActionType", "placement", "children", "width", "zIndex", "onImageClick", "withIcon"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var HBCalloutCornerPopup = function HBCalloutCornerPopup(_ref) {
  var isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    testId = _ref.testId,
    testIdName = _ref.testIdName,
    _ref$calloutTheme = _ref.calloutTheme,
    calloutTheme = _ref$calloutTheme === void 0 ? 'neutral' : _ref$calloutTheme,
    _ref$primaryActionTyp = _ref.primaryActionType,
    primaryActionType = _ref$primaryActionTyp === void 0 ? 'button' : _ref$primaryActionTyp,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'right' : _ref$placement,
    children = _ref.children,
    width = _ref.width,
    zIndex = _ref.zIndex,
    onImageClick = _ref.onImageClick,
    _ref$withIcon = _ref.withIcon,
    withIcon = _ref$withIcon === void 0 ? true : _ref$withIcon,
    contentProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useWindowSize = (0, _useWindowSize2.useWindowSize)(),
    isUpToSmall = _useWindowSize.isUpToSmall;
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    currStepIndex = _useState2[0],
    setCurrStepIndex = _useState2[1];
  var hasSteps = 'steps' in contentProps;
  var title;
  var description;
  var mediaPath;
  var actions;
  if (hasSteps) {
    var step = contentProps.steps[currStepIndex];
    title = step.title;
    description = step.description;
    mediaPath = step.mediaPath;
    actions = [{
      text: step.primaryActionText,
      onClick: function onClick(e) {
        var _contentProps$onStepC, _step$primaryActionOn;
        var isLastStep = currStepIndex === contentProps.steps.length - 1;
        var prevIndex = currStepIndex;
        var newIndex = isLastStep ? 0 : prevIndex + 1;
        setCurrStepIndex(newIndex);
        (_contentProps$onStepC = contentProps.onStepChange) === null || _contentProps$onStepC === void 0 || _contentProps$onStepC.call(contentProps, {
          prevIndex: prevIndex,
          newIndex: newIndex
        });
        (_step$primaryActionOn = step.primaryActionOnClick) === null || _step$primaryActionOn === void 0 || _step$primaryActionOn.call(step);
        if (isLastStep) {
          onClose(e);
        }
      }
    }];
    if ('secondaryActionText' in step) {
      actions.push({
        text: step.secondaryActionText,
        onClick: function onClick() {
          var _contentProps$onStepC2;
          var prevIndex = currStepIndex;
          var newIndex = prevIndex - 1;
          (_contentProps$onStepC2 = contentProps.onStepChange) === null || _contentProps$onStepC2 === void 0 || _contentProps$onStepC2.call(contentProps, {
            prevIndex: prevIndex,
            newIndex: newIndex
          });
          setCurrStepIndex(newIndex);
        }
      });
    }
  } else {
    title = contentProps.title;
    description = contentProps.description;
    mediaPath = contentProps.mediaPath;
    actions = contentProps.actions;
  }
  if (isUpToSmall) {
    return /*#__PURE__*/_react["default"].createElement(_HBDrawer["default"], {
      removeTopPadding: true,
      open: isOpen,
      onClose: onClose
    }, /*#__PURE__*/_react["default"].createElement(_HBCalloutPopoverContent["default"], (0, _extends2["default"])({
      calloutTheme: "neutral",
      primaryActionType: primaryActionType,
      actions: actions,
      testId: testId,
      testIdName: testIdName,
      actionsOrientation: "vertical",
      title: title,
      description: description,
      mediaPath: mediaPath,
      onImageClick: onImageClick,
      withIcon: withIcon
    }, hasSteps && {
      stepsContent: {
        currStep: currStepIndex + 1,
        totalSteps: contentProps.steps.length
      }
    }), children));
  }
  return /*#__PURE__*/_react["default"].createElement(_HBCornerPopup["default"], {
    isOpen: isOpen,
    onClose: null,
    testId: testId,
    padding: '0',
    testIdName: testIdName,
    placement: placement,
    width: width,
    zIndex: zIndex
  }, /*#__PURE__*/_react["default"].createElement(Container, {
    style: (0, _HBCalloutPopover.getCalloutPopoverStyles)()[calloutTheme]
  }, /*#__PURE__*/_react["default"].createElement(_HBCalloutPopoverContent["default"], (0, _extends2["default"])({
    onClose: onClose,
    calloutTheme: calloutTheme,
    primaryActionType: primaryActionType,
    actions: actions,
    testId: testId,
    testIdName: testIdName,
    title: title,
    description: description,
    mediaPath: mediaPath,
    onImageClick: onImageClick,
    withIcon: withIcon
  }, hasSteps && {
    stepsContent: {
      currStep: currStepIndex + 1,
      totalSteps: contentProps.steps.length
    }
  }), children)));
};
var _default = exports["default"] = HBCalloutCornerPopup; // -------------------------- Styles -------------------------- //
var Container = _styledComponents["default"].div.withConfig({
  displayName: "HBCalloutCornerPopup__Container",
  componentId: "sc-5mmksv-0"
})(["padding:20px;"]);
//# sourceMappingURL=HBCalloutCornerPopup.js.map